import type { SchematizedValues } from "components/Form/components/SchemaForm/SchemaForm.types";
import { schemaFormValidator } from "components/Form/Form.utils";
import { IconCollection } from "components/Icon/IconCollection";
import { RelationshipConfig } from "config/config";
import {
    DeleteListAction,
    deleteActionSignature,
} from "containers/Resources/components/CommonActions/CommonActions";
import { valueAndSchema } from "containers/Resources/screens/ResourcesSingle/constants";
import { isEqual } from "lodash";

const config: RelationshipConfig = {
    label: "Resource wrapper",
    icon: IconCollection.codeBraces,
    resourceName: "resource_wrapper",
    resourceClass: "relationship",
    parentReferenceField: "resource_id",
    parentReferenceName: "resource_id_resource.name",
    layout: [],
    hideCreateNew: true,
    actions: {
        shown: [],
        hidden: [deleteActionSignature],
    },
    listActions: {
        shown: [],
        hidden: [{ key: "delete", action: DeleteListAction }],
    },
    graphql: {
        resource: "resource_wrapper",
        resourceBody: `
            id
            resource_id
            resource_id_resource {
                resource_type
                name
                deleted_at
                is_readonly
            }
            wrapper_id
            wrapper_id_wrapper{
                input_schema
            }
            params
        `,
        createVariables: `
            $resource_id: String!
            $wrapper_id: String!
            $order: Int,
            $params: SchemalessData
        `,
        createQuery: `
            resource_id: $resource_id
            wrapper_id: $wrapper_id
            order: $order,
            params: $params
        `,
        updateVariables: `
            $id: String!,
            $by: String,
            $order: Int,
            $wrapper_id: String,
            $params: SchemalessData
        `,
        updateQuery: `
            order: $order,
            wrapper_id: $wrapper_id,
            params: $params
        `,
    },
    form: [
        {
            name: valueAndSchema,
            component: "schemaForm",
            fieldProps: {
                lang: "yaml",
                isReadOnly: false,
                canEnableSaveManually: true,
            },
            remappingSubmitDto: (value: SchematizedValues) => {
                return [
                    {
                        key: "params",
                        value: value.values,
                    },
                ];
            },
            isEqual: (valueA, valueB) => {
                return isEqual(valueA, valueB);
            },
            validation: schemaFormValidator,
        },
    ],
    formDTO: {
        initialValueDTO: (resourceData: any) => {
            const inputSchema = resourceData?.wrapper_id_wrapper.input_schema ?? {};
            const valueAndSchemaFieldValues: SchematizedValues = {
                values: resourceData?.params,
                schema: inputSchema,
            };
            return { ...resourceData, [valueAndSchema]: valueAndSchemaFieldValues };
        },
    },
    parentData: {
        parentDeletedAt: (data: any) => data?.resource_id_resource?.deleted_at,
        isParentReadOnly: (data: any) => data?.resource_id_resource?.is_readonly,
    },
};
export default config;
